import { MediaAdapterSubs } from "./MediaAdapter";
import { vp } from "../managers/vp";
import { settings } from "../const/Settings";
import { Subscription } from "../libs/listeners/Subscription";
export class TwitterAPIMediaAdapter {
    constructor() {
        this.name = 'TwitterAPIMediaAdapter';
        this.shortName = 'TAMA';
        this.listener = new Subscription();
        this._state = 'not_started';
        this.receiveMethodFromTwitterVideoPlayer = (event) => {
            const data = event.data;
            log('method ', event.data.method);
            switch (data.method) {
                case 'requestPlayerConfig':
                case 'videoPlayerMute':
                case 'videoPlayerUnmute':
                case 'requestDynamicAd':
                case 'videoPlayerReady':
                case 'videoView':
                    const videoViewParams = data.params[0];
                    break;
                case 'videoPlayerPlay':
                    const videoPlayerPlayParams = data.params[0];
                    this._state = "playing";
                    this.listener.inform(MediaAdapterSubs.onStateChange);
                    break;
                case 'videoPlayerPause':
                    this._state = "paused";
                    this.listener.inform(MediaAdapterSubs.onStateChange);
                    break;
                case 'videoPlayerPlaybackComplete':
                    this._state = "ended";
                    this.listener.inform(MediaAdapterSubs.onStateChange);
                    break;
            }
        };
    }
    init(params) {
        if (!window.twttr) {
            window.twttr = (function (d, s, id) {
                let js, fjs = d.getElementsByTagName(s)[0], t = window.twttr || {};
                if (d.getElementById(id))
                    return t;
                js = d.createElement(s);
                js.id = id;
                js.src = "https://platform.twitter.com/widgets.js";
                fjs.parentNode.insertBefore(js, fjs);
                t._e = [];
                t.ready = function (f) {
                    t._e.push(f);
                };
                return t;
            }(document, "script", "twitter-wjs"));
        }
        this._params = params;
    }
    onReady() {
        if (this._onReady) {
            return this._onReady;
        }
        return this._onReady = new Promise((resolve, reject) => {
            window.twttr.ready((twttr) => resolve());
        });
    }
    appendTo(playerHtml, autoPlay = false) {
        this._playerHtml = playerHtml;
        this.onReady().then(() => {
            window.twttr.widgets.createVideo(this._params.ref, playerHtml).then((el) => {
                this._iFrame = this._playerHtml.getElementsByTagName('iframe')[0];
                this._iFrame.contentWindow.addEventListener("message", this.receiveMethodFromTwitterVideoPlayer);
                this.update();
                window.addEventListener('resize', this.onResize.bind(this));
                if (autoPlay) {
                    this.play();
                    setTimeout(() => {
                        this.seek(10);
                    }, 4000);
                }
            });
        });
    }
    get iFrameDocument() {
        return this._iFrame.contentWindow.document;
    }
    onResize(e) {
        this.update();
    }
    update() {
        this.fitVideo();
    }
    fitVideo() {
        if (this._iFrame) {
            if (!vp.mediaQueries.matches(settings.mediaQueries.mqCollapseMenu)) {
                const newHeight = this._playerHtml.offsetHeight + 'px';
                if (newHeight) {
                    if (this._iFrame.style.height === null || this._iFrame.style.height !== newHeight) {
                        this._iFrame.style.height = newHeight;
                    }
                }
            }
            else {
                if (this.iFrameDocument) {
                    this.iFrameDocument.body.style.margin = '0';
                }
            }
        }
    }
    postMethodToTwitterVideoPlayer(method, params) {
        if (this.twitterVideoPlayerIFrame) {
            if (method === 'updateLayoutBreakpoint' || method === 'updatePosition') {
                if (!params) {
                    logger.error('method needs params');
                }
            }
            this.twitterVideoPlayerIFrame.contentWindow.postMessage(JSON.stringify({
                method: method,
                jsonrpc: "2.0",
                params: params
            }), "*");
        }
    }
    get twitterVideoPlayerIFrame() {
        return this.iFrameDocument.getElementsByTagName("iframe")[0] || null;
    }
    seek(value) {
    }
    play() {
        if (this.iFrameDocument) {
            const playCircle = this.iFrameDocument.getElementsByClassName("Icon--playCircle")[0];
            if (playCircle) {
                playCircle.click();
            }
            else {
                this.postMethodToTwitterVideoPlayer('play');
            }
        }
    }
    stop() {
        this.pause();
        this.seek(10);
    }
    get currentState() {
        return this._state;
    }
    pause() {
        this.postMethodToTwitterVideoPlayer('pause');
    }
    destroy() {
        if (this._iFrame && this._iFrame.contentWindow) {
            this._iFrame.contentWindow.removeEventListener("message", this.receiveMethodFromTwitterVideoPlayer);
        }
        window.removeEventListener('resize', this.onResize);
        this._player = null;
    }
}
